import NextLink from 'next/link';
import { DASHBOARD_PATH } from 'config';
import Logo from 'ui-component/Logo';

const LogoSection = () => (
  <NextLink href={DASHBOARD_PATH} passHref legacyBehavior>
    <a style={{ display: 'inline-block', lineHeight: 0 }}>
      <Logo />
    </a>
  </NextLink>
);

export default LogoSection;
